var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-router-relay/~/lodash/_Symbol.js
 ** module id = 603
 ** module chunks = 0
 **/